import { FC, ReactNode } from 'react';
import { Dropdown, DropdownProps, Flex, MenuProps } from 'antd';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { Icon } from '../Icon';
import { IconName } from '../Icon/types';

export type MenuItem = {
  label: ReactNode;
  icon?: IconName;
  color?: 'red';
  onClick: () => void;
  withSeparator?: boolean;
};

type DropdownMenuProps = Omit<DropdownProps, 'menu'> & {
  items: MenuItem[];
};

export const DropdownMenu: FC<DropdownMenuProps> = ({
  items,
  placement = 'bottomRight',
  children,
  ...props
}) => {
  const menuItems: MenuProps['items'] = [];

  items.forEach(({ icon, withSeparator, ...item }, index) => {
    if (withSeparator) {
      menuItems.push({
        type: 'divider',
        key: `divider-${index}`,
      });
    }

    menuItems.push({
      ...item,
      key: String(index),
      label: <ItemLabel {...{ icon, ...item }} />,
      onClick: (...args) => {
        //@ts-ignore
        args[0].domEvent.stopPropagation(); // TODO type prop onClick
        item.onClick();
      },
    });
  });

  return (
    <Dropdown menu={{ items: menuItems }} placement={placement} trigger={['click']} {...props}>
      <StyledFlex justify="center" align="center" onClick={(e) => e.stopPropagation()}>
        {children ? children : <Icon name="dots-three-vertical" style={{ cursor: 'pointer' }} />}
      </StyledFlex>
    </Dropdown>
  );
};

const ItemLabel: FC<MenuItem> = ({ label, icon, color }) => {
  return (
    <ItemLabelContainer className={cn({ ['red']: color === 'red' })}>
      {icon && <Icon name={icon} size="s16" />}
      {label}
    </ItemLabelContainer>
  );
};

const StyledFlex = styled(Flex)`
  cursor: 'pointer';
  height: '100%';
`;

const ItemLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &.red {
    color: ${COLORS.systemFlame200};
  }
`;
